import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import { useContentFilter } from '../../../../../../utils/hooks/useContentFilter';
import { useIsCurrentUserDeviationAuthor } from '../../../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useRestrictToLoggedIn } from '../../../../../../utils/hooks/useRestrictToLoggedIn';
import { LoggedOutReturnType } from '../../../../../../redux/loggedout';
import { getDeviationPremiumDownload } from '../../../../../../ActionBar/buttons/DownloadButton/permissions';
import { useTranslation } from 'react-i18next';
const logger = ddt.createLogger('downloadbutton');
const BuyPremiumContentButton = ({ deviation, onDownload })=>{
    var _deviation_extended_pcp, _deviation_extended, _deviation_extended_pcp1, _deviation_extended1;
    const { t } = useTranslation();
    const { isLoggedIn, sendUserToJoinPage } = useRestrictToLoggedIn();
    const { contentFilter, pushUserSettingsModal } = useContentFilter();
    logger.log('PremiumDownloadButton, deviation:', deviation);
    const isOwner = useIsCurrentUserDeviationAuthor(deviation);
    const { download, permission } = getDeviationPremiumDownload(deviation, isOwner);
    logger.log({
        isOwner,
        download,
        permission
    });
    if (!download) {
        logger.log('has no downloads');
        return null;
    }
    let buttonProps = {
        biData: PureBiData({
            evid: 350,
            ispaiddownload: 1,
            deviationid: deviation.deviationId,
            sectionname: 'side_rail'
        }),
        icon: permission === 'downloadable' ? DownloadIcon : undefined,
        variant: 'solid',
        size: 'large',
        rounded: true,
        fillContainerWidth: true
    };
    const isPurchasable = permission === 'purchasable';
    const checkoutUrl = ((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_pcp = _deviation_extended.pcp) === null || _deviation_extended_pcp === void 0 ? void 0 : _deviation_extended_pcp.subproductId) ? Url.checkoutLink((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_pcp1 = _deviation_extended1.pcp) === null || _deviation_extended_pcp1 === void 0 ? void 0 : _deviation_extended_pcp1.subproductId) : undefined;
    const buttonLabel = t(permission === 'downloadable' ? 'sidebar.pcpInfo.button.download' : 'sidebar.pcpInfo.button.purchase', {
        dollarPrice: deviation.pcp.downloadDollarPrice
    });
    // send anon to sisu
    if (!isLoggedIn) {
        return /*#__PURE__*/ React.createElement(BuyButton, _object_spread_props(_object_spread({}, buttonProps), {
            onClick: ()=>sendUserToJoinPage(ReferralType.ANON_DOWNLOAD, checkoutUrl, LoggedOutReturnType.JOIN_ONLY)
        }), buttonLabel);
    }
    // still needs to purchase at checkout
    if (isPurchasable && !!checkoutUrl) {
        // we may need them to update their mature content settings before
        // sending them to checkout or ponies will 404 the page
        const needsBrowsingModeChange = deviation.isMature && contentFilter !== 'mature';
        buttonProps = needsBrowsingModeChange ? _object_spread_props(_object_spread({}, buttonProps), {
            onClick: ()=>pushUserSettingsModal()
        }) : _object_spread_props(_object_spread({}, buttonProps), {
            href: checkoutUrl
        });
    // is it already purchased?
    } else if (permission === 'downloadable') {
        buttonProps = _object_spread_props(_object_spread({}, buttonProps), {
            href: download.url,
            target: '_blank',
            download: true,
            onClick: onDownload
        });
    }
    return /*#__PURE__*/ React.createElement(BuyButton, buttonProps, buttonLabel);
};
BuyPremiumContentButton.displayName = 'BuyPremiumContentButton';
export default BuyPremiumContentButton;
